import gql from "graphql-tag";

export default gql`
	query getRenewableSubscriptions {
		getRenewableSubscriptions {
			subscriptionID
			name
			expirationDate
			isTrial
		}
	}
`;

export const readRenewableSubscriptions = ({ data }) => data && data.getRenewableSubscriptions;
